import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useState} from "react";


export interface ConfirmationDialogProps {
	  title?: string;
	  contentText?: string;
	  onClose: () => void;
	  onConfirmed: () => void;
}


export default function APXConfirmationDialog({
																	title = "Confirm",
																	contentText = "Are you sure? You cannot undo this action.",
																	onClose,
																	onConfirmed
															 }: ConfirmationDialogProps) {
	  const [open, setOpen] = useState(true);
	  const handleClose = () => {
			 setOpen(false);
			 onClose();
	  };
	  const handleConfirmation = () => {
			 handleClose();
			 onConfirmed();
	  };
	  return (
				 <Dialog fullWidth
							open={open}
							onClose={(event, reason) => {
								  if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
										 handleClose();
								  }
							}}
				 >
						<DialogTitle>{title}</DialogTitle>
						<DialogContent>
							  <DialogContentText>{contentText}</DialogContentText>
						</DialogContent>
						<DialogActions>
							  <Button variant={"outlined"} onClick={handleClose}>Cancel</Button>
							  <Button variant={"contained"} onClick={handleConfirmation}>Confirm</Button>
						</DialogActions>
				 </Dialog>
	  );
}